export default "__VITE_ASSET__32b7b697__"